import ErrorFeedback from 'Components/ErrorFeedback'
import {
  ANY_ITEM,
  COPY,
  DO_NOTHING,
  GROUP_MAX_ITEMS,
  modalEndConditionState,
  MOVE
} from 'Hooks/useModalEndCondition/useModalEndCondition'
import {
  Button,
  Flex,
  FlexItem,
  FormElement,
  Loading,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead,
  RadioButton,
  Select,
  SPACING_4,
  SpacingVertical
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilState } from 'recoil'

const SELECT_TYPE_COPY = 0
const SELECT_TYPE_MOVE = 1
const SELECT_TYPE_MOVE_TO = 2

const RadioCondition = ({ check, setCheck, condition, label }) => {
  const intl = useIntl()
  return (
    <RadioButton
      labelClassName='modal-end-condition__radio-button-label'
      value={condition}
      checked={check === condition}
      label={intl.formatMessage({
        id: label
      })}
      onChange={() => {
        setCheck((prev) => ({
          ...prev,
          check: condition,
          selectedGroups: [],
          selectedGroupsTo: []
        }))
      }}
      data-mu-test={`modal-end-condition-radio-${condition}`}
    />
  )
}

const ModalEndCondition = ({
  handleCancel,
  handleConfirm,
  fetchGroups,
  fetchGroup
}) => {
  const intl = useIntl()

  // init
  // const { fetch, fetchGroup } = useModalEndCondition()

  const [
    {
      loading,
      loaded,
      error,
      errMessage,
      severity,
      items,
      check,
      copyValue,
      moveToValue,
      moveFromValue,
      show,
      close,
      selectedGroups,
      selectedGroupsTo,
      count,
      loadGroups,
      loadGroup,
      selectCollapsed
    },
    setState
  ] = useRecoilState(modalEndConditionState)

  const [initialState, setInitialState] = useState({})

  // gruppi
  const [search, setSearch] = useState({ type: -1, valueToSearch: '' })
  const [options, setOptions] = useState([])
  const [optionsAnyItem, setOptionsAnyItem] = useState([])

  // reset della ricerca
  useEffect(() => {
    search.valueToSearch === '' && fetchGroups('')
  }, [search])

  useEffect(() => {
    if (selectCollapsed) {
      setState((prev) => ({
        ...prev,
        selectCollapsed: false
      }))
      fetchGroups('')
    }
  }, [selectCollapsed])

  useEffect(() => {
    if (items && items.length > 0) {
      const optionsUpdated = [...items] // lista corrente

      for (let i = 0; i < selectedGroups.length; i++) {
        selectedGroups[i].value > 0 &&
          !optionsUpdated.find((e) => e.value === selectedGroups[i].value) &&
          optionsUpdated.unshift(selectedGroups[i])
      }
      for (let i = 0; i < selectedGroupsTo.length; i++) {
        selectedGroupsTo[i].value > 0 &&
          !optionsUpdated.find((e) => e.value === selectedGroupsTo[i].value) &&
          optionsUpdated.unshift(selectedGroupsTo[i])
      }

      setOptionsAnyItem([ANY_ITEM, ...optionsUpdated])
      setOptions(optionsUpdated)
    }
  }, [items, selectedGroups, selectedGroupsTo])

  // end gruppi

  useEffect(() => {
    if (show) {
      // store initialState
      setInitialState({
        check,
        copyValue,
        moveToValue,
        moveFromValue
      })
      setState((prev) => ({
        ...prev,
        close: false
      }))
    }
  }, [show])

  useEffect(() => {
    close && handleCancel()
  }, [close])

  const handleSelectChange = useCallback(async (e) => {
    if (!e) {
      return // l'utente seleziona l'etichetta
    }
    setState((prev) => ({
      ...prev,
      copyValue: { label: '', value: -1 }
    }))
    setSearch((prev) => ({
      ...prev,
      type: SELECT_TYPE_COPY
    }))

    const group = await fetchGroup(e)
    const sGroup = selectedGroups.slice(0)
    !sGroup.find((e) => e.value === group.value) && sGroup.push(group)

    setState((prev) => ({
      ...prev,
      copyValue: group,
      moveToValue: { label: '', value: -1 },
      moveFromValue: { label: '', value: -1 },
      selectedGroups: sGroup,
      selectCollapsed: true
    }))
  })

  const handleSelectMoveFromChange = useCallback(async (e) => {
    setState((prev) => ({
      ...prev,
      moveFromValue: { label: '', value: -1 }
    }))
    setSearch((prev) => ({
      ...prev,
      type: SELECT_TYPE_MOVE
    }))

    const group = e !== 0 ? await fetchGroup(e) : ANY_ITEM
    const sGroup = selectedGroups.slice(0)
    !sGroup.find((e) => e.value === group.value) && sGroup.push(group)
    setState((prev) => ({
      ...prev,
      moveFromValue: group,
      copyValue: { label: '', value: -1 },
      selectedGroups: sGroup,
      selectCollapsed: true
    }))
  })

  const handleSelectMoveToChange = useCallback(async (e) => {
    if (!e) {
      return // l'utente seleziona l'etichetta
    }
    setState((prev) => ({
      ...prev,
      moveToValue: { label: '', value: -1 }
    }))
    setSearch((prev) => ({
      ...prev,
      type: SELECT_TYPE_MOVE_TO
    }))

    const group = await fetchGroup(e)
    const sGroup = selectedGroupsTo.slice(0)
    !sGroup.find((e) => e.value === group.value) && sGroup.push(group)
    setState((prev) => ({
      ...prev,
      moveToValue: group,
      copyValue: { label: '', value: -1 },
      selectedGroupsTo: sGroup,
      selectCollapsed: true
    }))
  })

  const getHint = () => {
    if (!count && !loadGroups && search.valueToSearch !== '') {
      return intl.formatMessage({
        id: 'Load.MailupCommon.InputStatusNoMatches'
      })
    }

    if (count > GROUP_MAX_ITEMS) {
      return intl.formatMessage({
        id: 'Load.Filters.ActivityMessagesMoreResults'
      })
    }

    if (loadGroups) {
      return intl.formatMessage({
        id: 'Load.MailupCommon.InputStatusLoading'
      })
    }
  }

  const displayErrorMessage =
    check === MOVE && moveToValue && moveFromValue
      ? moveToValue.value === moveFromValue.value &&
        moveFromValue.value !== -1 &&
        moveToValue.value !== -1
      : false

  const isDisable = () => {
    let ret = false
    if (check === MOVE) {
      ret =
        moveToValue && moveFromValue
          ? moveToValue.value === moveFromValue.value ||
            moveFromValue.value === -1 ||
            moveToValue.value === -1
          : true
    } else if (check === COPY) {
      ret = copyValue ? copyValue.value === -1 : true
    } else if (check === DO_NOTHING) {
      ret = false
    }
    return ret
  }

  const handleConfirmButton = () => {
    if (check === COPY) {
      handleConfirm({ check, copyValue })
    } else if (check === MOVE) {
      handleConfirm({
        check,
        moveFromValue,
        moveToValue
      })
    } else if (check === DO_NOTHING) {
      handleConfirm({ check })
    }
  }

  const handleClose = useCallback((e) => {
    // reset to initialState
    setState((prev) => ({
      ...prev,
      moveToValue: initialState.moveToValue,
      copyValue: initialState.copyValue,
      moveFromValue: initialState.moveFromValue,
      check: initialState.check,
      close: true,
      error: false,
      errMessage: ''
    }))
  })

  const handleSearch = (valueToSearch, type) => {
    setSearch({ type, valueToSearch })
    fetchGroups(valueToSearch)
    return valueToSearch
  }

  const isLoading = (type) => {
    return search.type === type
  }

  return (
    <>
      <Modal
        data-mu-test='modal-end-step-messages'
        show={show}
        showClose
        onClose={handleClose}
        closeOnOverlayClick
        size={MODAL_SIZE_MD}
      >
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.AutomationWorkflow.EndConditionTitleModal'
          })}
        />
        <ModalBody>
          <Loading open={loading} />
          <ErrorFeedback error={errMessage} severity={severity} />
          {!error && loaded && (
            <>
              <Flex flexDirection='column' rowGap='24px'>
                <FlexItem>
                  <RadioCondition
                    check={check}
                    setCheck={setState}
                    condition={DO_NOTHING}
                    label='Load.AutomationWorkflow.EndConditionNothing'
                  />
                </FlexItem>
                <FlexItem>
                  <RadioCondition
                    check={check}
                    setCheck={setState}
                    condition={COPY}
                    label='Load.AutomationWorkflow.EndConditionCopy'
                  />
                  <SpacingVertical variant={SPACING_4} />
                  <Select
                    value={check === COPY && copyValue && copyValue.value}
                    searchable
                    onChange={handleSelectChange}
                    onSearch={(e) => {
                      return handleSearch(e, SELECT_TYPE_COPY)
                    }}
                    options={options}
                    hint={getHint()}
                    disabled={check !== COPY}
                    loading={loadGroup && isLoading(SELECT_TYPE_COPY)}
                    placeholder={intl.formatMessage({
                      id: 'Load.MailupCommon.SelectGroup'
                    })}
                  />
                </FlexItem>
                <FlexItem>
                  <RadioCondition
                    check={check}
                    setCheck={setState}
                    condition={MOVE}
                    label='Load.AutomationWorkflow.EndConditionMove'
                  />

                  <Flex
                    justifyContent='space-between'
                    alignItems='flex-start'
                    margin='4px 0 0 0'
                    gap='8px'
                  >
                    <FlexItem width='260px'>
                      <Select
                        value={
                          check === MOVE && moveFromValue && moveFromValue.value
                        }
                        searchable
                        onChange={handleSelectMoveFromChange}
                        onSearch={(e) => {
                          return handleSearch(e, SELECT_TYPE_MOVE)
                        }}
                        options={optionsAnyItem}
                        hint={getHint()}
                        disabled={check !== MOVE}
                        loading={loadGroup && isLoading(SELECT_TYPE_MOVE)}
                        placeholder={intl.formatMessage({
                          id: 'Load.MailupCommon.SelectGroup'
                        })}
                      />
                    </FlexItem>
                    <FlexItem margin='8px 0 0 0'> a </FlexItem>
                    <FlexItem width='260px'>
                      <FormElement
                        feedback={
                          displayErrorMessage
                            ? intl.formatMessage({
                                id: 'Load.AutomationWorkflow.EndConditionMoveMessageError'
                              })
                            : undefined
                        }
                        feedbackVariant={
                          displayErrorMessage ? 'danger' : undefined
                        }
                      >
                        <Select
                          value={
                            check === MOVE && moveToValue && moveToValue.value
                          }
                          searchable
                          onChange={handleSelectMoveToChange}
                          options={options}
                          onSearch={(e) => {
                            return handleSearch(e, SELECT_TYPE_MOVE_TO)
                          }}
                          hint={getHint()}
                          disabled={check !== MOVE}
                          loading={loadGroup && isLoading(SELECT_TYPE_MOVE_TO)}
                          placeholder={intl.formatMessage({
                            id: 'Load.MailupCommon.SelectGroup'
                          })}
                          error={displayErrorMessage}
                        />
                      </FormElement>
                    </FlexItem>
                  </Flex>
                </FlexItem>
              </Flex>
            </>
          )}
        </ModalBody>
        {!error && (
          <ModalFoot>
            <Button
              kind='secondary'
              onClick={handleClose}
              data-mu-test='button-cancel'
            >
              {intl.formatMessage({
                id: 'Load.MailupCommon.Cancel'
              })}
            </Button>

            <Button
              kind='primary'
              disabled={isDisable()}
              onClick={handleConfirmButton}
              data-mu-test='button-confirm'
            >
              {intl.formatMessage({
                id: 'Load.MailupCommon.Save'
              })}
            </Button>
          </ModalFoot>
        )}
      </Modal>
    </>
  )
}

ModalEndCondition.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  fetchGroups: PropTypes.func,
  fetchGroup: PropTypes.func
}

RadioCondition.propTypes = {
  check: PropTypes.number,
  condition: PropTypes.string,
  setCheck: PropTypes.func,
  label: PropTypes.string
}

export default ModalEndCondition
